import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  EstimateItemModel,
  SubscriptionEstimatesModel,
} from '@app/+authenticated/+reports/shared/subscriptions/subscription.model';
import { LocaleDatePipe } from '@app/pipes/locale-date.pipe';
import { SubscriptionCurrencyPipe } from '@app/pipes/subscription-currency.pipe';
import { TranslationParamsPipe } from '@app/pipes/translation-params.pipe';
import { VatResponseStatus } from '@app/shared/billing/billing.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { clsx } from 'clsx';

import { VatChanges } from '../../forms/billing-details/billing-details-form.component';
import { OrderSummaryRowComponent } from '../order-summary-row/order-summary-row.component';

@Component({
  selector: 'order-summary-content',
  templateUrl: './order-summary-content.component.html',
  standalone: true,
  imports: [OrderSummaryRowComponent, TranslateModule, TranslationParamsPipe, SubscriptionCurrencyPipe, LocaleDatePipe],
})
export class OrderSummaryContentComponent implements OnChanges, AfterViewInit {
  @HostBinding('class')
  public hostClasses = clsx('flex flex-col gap-4');

  @Input({ required: true })
  public estimates: SubscriptionEstimatesModel;

  @Input()
  public yearlyBilling: boolean;

  @Input()
  public hasIntegrationPlus: boolean;

  @Input()
  public countryCode: string;

  @Output()
  public initialized = new EventEmitter<void>();

  // TODO: This could be an input if it has to be defined in subscription-dialog as well
  public planItem: EstimateItemModel;

  public integrationPlusPrice: number;

  public _vatNote = '[countryCode] [vatPercentage]%';
  public vatNote = this._vatNote; // Default value
  public vatPercentage = 0;

  @Input()
  public set vatInfo(changes: VatChanges) {
    if (changes) {
      this.vatNote =
        changes.vatNumber && changes.status === VatResponseStatus.UNDETERMINED
          ? `${this._vatNote} ${this.translate.instant('(could not validate VAT number)')}`
          : this._vatNote;
    }
  }

  public constructor(private readonly translate: TranslateService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['estimates']) {
      this.planItem = this.estimates.line_items?.find((item) => item.entity_type === 'plan_item_price');

      const integrationPlusItem = this.estimates.line_items?.find((item) => item.entity_type === 'addon_item_price');

      if (integrationPlusItem) {
        this.integrationPlusPrice = integrationPlusItem.amount / 100;
      }

      // estimate.taxes[0].description example: 'VAT @ 21 %'
      const taxDescription = this.estimates.taxes?.length ? this.estimates.taxes[0]?.description : null;
      // extract number after "@"
      if (taxDescription) {
        this.vatPercentage = parseInt(taxDescription.substring(taxDescription.indexOf('@') + 1));
      }
    }
  }

  public ngAfterViewInit(): void {
    this.initialized.emit();
  }
}
